import { HarvestContainer } from '@modules/harvest/containers/harvest_container';
import { HarvestView } from '@modules/harvest/views/harvest_view';
import { useCallback } from 'react';
import { toast } from 'sonner';

export function HarvestScreen() {
  const onError = useCallback((message: string) => {
    toast.error(message);
  }, []);

  return <HarvestContainer View={HarvestView} onError={onError} />;
}
